"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _reactstrap = require("reactstrap");

require("./CardFormat.scss");

require("./CardFormatDark.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var CardFormat = function CardFormat(props) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    id: props.id,
    className: 'gcl-cards-format'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-cards-wraper-format ".concat(props.check ? 'checked' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-head-cards-format"
  }, props.title, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "gcl-button-format",
    color: "tertiary"
  }, props.btnRigth)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-cards-body-format gcl-cards-body-color ".concat(props.check ? 'checked' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: 'glc-content' + props.id,
    className: "gcl-title-cards-format"
  }, props.content), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-content-date-cards-format"
  }, props.date), /*#__PURE__*/_react["default"].createElement("div", {
    id: 'glc-body' + props.id,
    className: "gcl-description-cards-format"
  }, props.body)))), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    className: "gcl-tooltip-format-card",
    placement: "top",
    target: 'glc-content' + props.id,
    boundariesElement: "window"
  }, props.content), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    className: "gcl-tooltip-format-card",
    placement: "top",
    target: 'glc-body' + props.id,
    boundariesElement: "window"
  }, props.body));
};

CardFormat.defaultProps = {
  id: '1',
  tittle: '',
  content: '',
  btnRigth: '',
  date: '',
  body: '',
  check: false,
  iconActive: false,
  icon: 'home',
  iconLabel: ''
};
CardFormat.propTypes = {
  id: _propTypes["default"].string,
  title: _propTypes["default"].string,
  icon: _propTypes["default"].string,
  content: _propTypes["default"].string,
  btnRigth: _propTypes["default"].object,
  date: _propTypes["default"].string,
  check: _propTypes["default"].bool,
  iconActive: _propTypes["default"].bool,
  iconLabel: _propTypes["default"].string,
  body: _propTypes["default"].string
};
var _default = CardFormat;
exports["default"] = _default;